import React from 'react';
import { Row, Button } from 'reactstrap';
import { Share2 } from 'react-feather'
// Market Icon Import
import nielsen from '../../../assets/images/markets/nielsen.png';
import mintel from '../../../assets/images/markets/mintel.png';
import npd from '../../../assets/images/markets/npd.png';
import crunchbase from '../../../assets/images/markets/crunchbase.png';
import cxi from '../../../assets/images/markets/cxi.png';
import sapLogo from '../../../assets/images/markets/sap.png';
import integrationImages from '../../integration/images';

const Markets = () => {
  return (
    <div className={"page-content container-fluid"} style={{ marginBottom: 35 }}>
      <div className="analytics-markets">
        <Row className="markets-intro">
          <h4 className={'mb-3'}>Connect your market research data to your innovation team.</h4>
          <p>Whether it's your own data or third-party data, find out more about our key partners and contact us to connect to other partners.</p>
        </Row>
        <Row>
          <div className={"market-connection"}>
            <span>
              <img src={npd}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=NPD Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={crunchbase}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Crunchbase Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={mintel}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Mintel Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={nielsen}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Nielsen Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          {/* New Markets */}
          <div className={"market-connection"}>
            <span>
              <img src={integrationImages.airtable.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Airtable Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={integrationImages.google_cloud.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Google Cloud Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          {/* <div className={"market-connection"}>
            <span>
              <img src={integrationImages.google_sheets.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Google Sheets Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div> */}
          <div className={"market-connection"}>
            <span>
              <img src={integrationImages.ibm.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=IBM Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={integrationImages.odoo.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Odoo Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={integrationImages.microsoft_dynamics.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Microsoft Dynamics Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={integrationImages.oracle.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Oracle ERP Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={sapLogo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=SAP.io Marketplace Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          <div className={"market-connection"}>
            <span>
              <img src={integrationImages.shopify.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Shopify Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div>
          {/* <div className={"market-connection"}>
            <span>
              <img src={integrationImages.excel.logo}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Excel Inquiry">
              <Button color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Request
              </Button>
            </a>
          </div> */}

          <div className={"market-connection"}>
            <span>
              <img src={cxi}></img>
            </span>
            <a href="mailto:sales@journeyfoods.com?subject=Customerx.i Inquiry">
              <Button disabled={true} color="secondary" outline className="mt-4 color-battleship-grey">
                <Share2 className="mr-2 color-battleship-grey" size={17} />
                Coming Soon
              </Button>
            </a>
          </div>
          {/* <div className={"market-connection"}>
              <span style={{height: 150}}>
                <img src={iri} width={150} ></img>
              </span>
              <Button color="secondary" style={{backgroundColor: '#3f65f1'}} outline className="mt-4">
                <Share2 className="mr-2" color="#fff" size={17} />
                Connect
              </Button>
            </div> */}
        </Row>
      </div>

    </div>
  )
};

export default Markets